import { memo } from 'react';
import { useAuth } from 'react-oidc-context';
import { Album } from '../../types';
import { canUpdateContributorMedia } from '@utils/authUtils.ts';

interface AdminMediaUpdateButtonProps {
  album: Album;
  className?: string;
  onOpenModal: (album: Album) => void;
}

export const AdminMediaUpdateButton = memo(
  ({ album, className = '', onOpenModal }: AdminMediaUpdateButtonProps) => {
    const auth = useAuth();

    if (!canUpdateContributorMedia(auth.user)) {
      return null;
    }

    const contributor =
      album.contributors && album.contributors.length > 0
        ? album.contributors[0]
        : null;

    if (!contributor) {
      return null;
    }

    return (
      <>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onOpenModal(album);
          }}
          className={`flex items-center justify-center w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/30 transition-colors duration-200 ${className}`}
          title="Update Contributor Media (Admin Only)">
          <svg
            width={16}
            height={16}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-white">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
          </svg>
        </button>
      </>
    );
  },
);

AdminMediaUpdateButton.displayName = 'AdminMediaUpdateButton';

export default AdminMediaUpdateButton;
